import React from 'react'
import TransactionTable from "./components/TransactionTable";
function EvomTransactions() {
    return (
        <div>
          <TransactionTable />
        </div>
    )
}

export default EvomTransactions
